module.exports = __webpack_public_path__ + "17341a48df11b6de12bd1c99ac0cfcbc.png";